import React, { useState } from "react";
import { List, Typography } from "@material-ui/core";
import { AccountGroup, BrightnessPercent } from "mdi-material-ui";
import Divider from '@material-ui/core/Divider';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import FolderSpecialIcon from '@material-ui/icons/FolderSpecial';
import { BarChart, CloudUpload, Dashboard, Search, Assignment, Loop, TrendingUp, NoteAdd, Face, FolderSpecial, Error, Settings, EventAvailable } from '@material-ui/icons';
import CustomMenuItem from "./CustomMenuItem";
import { getRole, getShortName } from "../../Common/utils/auth";
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

interface SideMenuProps {
  isMenuOpened?: boolean;
}

const SideMenu: React.FC<SideMenuProps> = ({ isMenuOpened }) => {
  //   const userData = parseJwt();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [today, setDate] = useState(new Date());

  const hour = today.getHours();
  const wish = `Good ${(hour < 12 && "Morning") || (hour < 17 && "Afternoon") || "Evening"
    }, `;
  const userGreetings = () => {
    return (
      <div>
        <h4>{wish}{getShortName()}</h4>
        <Divider />
      </div>
    );
  };

  React.useLayoutEffect(() => {
    const ROUTES: string[] = [


      "/customer",
      "/home",
      "/olddatamanagement",
      "/customerdocs",
      "/reports",
      "/connection",
      "/delivery",
      "/dailyconsumer",
      "/refillsale",
      "/vechile",
      "/transaction",
      "/completefinger",
      "/agentlist",
      "/member",
      "/trash",
      "/profile",
      "/dash",
      "/reset",
      "/agentdash",
      "/fingerprint",
      "/agentdashboard",
      "/svreadylist",

    ];
    let index = -1;
    ROUTES.forEach((d, i) => {
      if (window.location.pathname.includes(d)) {
        index = i;
      }
      if (index !== -1) {
        setSelectedIndex(index);
      }
    });
  }, [window.location.pathname]);

  return (
    <div style={{ height: "100vh" }}>

      <div style={{
        paddingTop: "1rem", textAlign: "center"
      }}>
        <Typography style={{ backgroundColor: "#004e8e", color: "white" }}>
          {userGreetings()}
        </Typography>
      </div>
      <div style={{ paddingTop: "3rem", backgroundColor: "#004e8e", color: "white" }}>

        <List
          className={`side-menu-list custom-side-menu ${isMenuOpened ? "menu-opened" : "menu-closed"
            }`}
        >
          {getRole() !== "user" && (
            <div >
              <CustomMenuItem
                index={0}
                selectedIndex={selectedIndex}
                to="/customer"
                onClick={setSelectedIndex}
                titleText="New Registration"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 0 ? "selected-menu" : ""
                  }`}
                icon={<PersonAddIcon color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={1}
                selectedIndex={selectedIndex}
                to="/home"
                onClick={setSelectedIndex}
                titleText="Find Consumer"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 1 ? "selected-menu" : ""
                  }`}
                icon={<Search color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={2}
                selectedIndex={selectedIndex}
                to="/olddatamanagement"
                onClick={setSelectedIndex}
                titleText="Find Old Consumer"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 2 ? "selected-menu" : ""
                  }`}
                icon={<FolderSpecialIcon color="secondary" fontSize="large" />}
              />

              <CustomMenuItem
                index={3}
                selectedIndex={selectedIndex}
                to="/customerdocs"
                onClick={setSelectedIndex}
                titleText="Doc Management"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 3 ? "selected-menu" : ""
                  }`}
                icon={<CloudUpload color="secondary" fontSize="large" />}
              />


              <CustomMenuItem
                index={4}
                selectedIndex={selectedIndex}
                to="/reports"
                onClick={setSelectedIndex}
                titleText="Dashboard"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 4 ? "selected-menu" : ""
                  }`}
                icon={<Dashboard color="secondary" fontSize="large" />}
              />

              <CustomMenuItem
                index={5}
                selectedIndex={selectedIndex}
                to="/connection"
                onClick={setSelectedIndex}
                titleText="Sale & Connection"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 5 ? "selected-menu" : ""
                  }`}
                icon={<TrendingUp color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={6}
                selectedIndex={selectedIndex}
                to="/delivery"
                onClick={setSelectedIndex}
                titleText="NC Dashboard"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 6 ? "selected-menu" : ""
                  }`}
                icon={<BarChart color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={7}
                selectedIndex={selectedIndex}
                to="/dailyconsumer"
                onClick={setSelectedIndex}
                titleText="DateWise Report"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 7 ? "selected-menu" : ""
                  }`}
                icon={<EventAvailable color="secondary" fontSize="large" />}
              />




            </div>
          )}
          {getRole() === "user" && (
            <div>


              <CustomMenuItem
                index={11}
                selectedIndex={selectedIndex}
                to="/home"
                onClick={setSelectedIndex}
                titleText="Find Consumer"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 11 ? "selected-menu" : ""
                  }`}
                icon={<Search color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={12}
                selectedIndex={selectedIndex}
                to="/agentdashboard"
                onClick={setSelectedIndex}
                titleText="Dashbaord"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 12 ? "selected-menu" : ""
                  }`}
                icon={<BarChart color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={13}
                selectedIndex={selectedIndex}
                to="/olddatamanagement"
                onClick={setSelectedIndex}
                titleText="Old Consumer"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 13 ? "selected-menu" : ""
                  }`}
                icon={<FolderSpecial color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={14}
                selectedIndex={selectedIndex}
                to="/connection"
                onClick={setSelectedIndex}
                titleText="Sales & Connection"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 14 ? "selected-menu" : ""
                  }`}
                icon={<TrendingUp color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={15}
                selectedIndex={selectedIndex}
                to="/fingerprint"
                onClick={setSelectedIndex}
                titleText="Fingerprint & SwasthyaSathi Pending"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 15 ? "selected-menu" : ""
                  }`}
                icon={<NoteAdd color="secondary" fontSize="large" />}
              />

              <CustomMenuItem
                index={16}
                selectedIndex={selectedIndex}
                to="/rejectfingerPrint"
                onClick={setSelectedIndex}
                titleText="Reject & Return Doc"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 16 ? "selected-menu" : ""
                  }`}
                icon={<Error color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={17}
                selectedIndex={selectedIndex}
                to="/completefingerPrint"
                onClick={setSelectedIndex}
                titleText="Complete Fingerprint and SwasthyaSathi Pending"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 17 ? "selected-menu" : ""
                  }`}
                icon={<AssignmentTurnedInIcon color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={17}
                selectedIndex={selectedIndex}
                to="/svreadylist"
                onClick={setSelectedIndex}
                titleText="Sv Ready List"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 17 ? "selected-menu" : ""
                  }`}
                icon={<AssignmentTurnedInIcon color="secondary" fontSize="large" />}
              />
              <CustomMenuItem
                index={18}
                selectedIndex={selectedIndex}
                to="/profile"
                onClick={setSelectedIndex}
                titleText="Profile"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 18 ? "selected-menu" : ""
                  }`}
                icon={<Face color="secondary" fontSize="large" />}
              />


            </div>
          )}

          {getRole() === "superadmin" && (
            <div>

              <CustomMenuItem
                index={19}
                selectedIndex={selectedIndex}
                to="/products"
                onClick={setSelectedIndex}
                titleText="Product Management"
                class={`menu-link fs-16 fw-medium ${selectedIndex === 19 ? "selected-menu" : ""
                  }`}
                icon={<CurrencyBitcoinIcon color="secondary" fontSize="large" />}
              />


            </div>
          )

          }
        </List>
      </div>
    </div>
  );
};

export default SideMenu;
